import { MatIconModule } from '@angular/material/icon';
import { BreadcrumbsComponent } from '../../breadcrumbs/breadcrumbs.component';
import { Breadcrumbs } from './../../../../core/types/interfaces';
import { Component, inject, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ToggleFilterComponent } from '../../toggle-filter/toggle-filter.component';
import { WebHeaderOptionsService } from '../../../../core/services/web-header-options/web-header-options.service';
import { ResidentNoteComponent } from '../../resident-note/resident-note.component';
import { Customer } from '../../../models/customer.model';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-page-sub-header',
  templateUrl: './page-sub-header.component.html',
  styleUrls: ['./page-sub-header.component.scss'],
  imports: [
    BreadcrumbsComponent,
    MatIconModule,
    CommonModule,
    TranslatePipe,
    ToggleFilterComponent,
    FormsModule,
    ReactiveFormsModule,
    ResidentNoteComponent,
    MatProgressSpinnerModule,
  ],
})
export class PageSubHeaderComponent {
  @Input() isFirstLogin: boolean = false;
  @Input() customer: Customer | null = null;

  private webHeaderOptionsService = inject(WebHeaderOptionsService);
  private router = inject(Router);

  resident = toSignal(this.webHeaderOptionsService.getPageResident());
  title = toSignal(this.webHeaderOptionsService.getTitle(), {
    initialValue: '',
  });
  breadcrumbs = toSignal(this.webHeaderOptionsService.getBreadcrumbs(), {
    initialValue: [] as Breadcrumbs[],
  });
  options = toSignal(this.webHeaderOptionsService.getWebHeaderOptions());

  navigateBack() {
    const breadcrumbs = this.breadcrumbs().filter(x => x.url);
    const url = breadcrumbs[breadcrumbs.length - 1].url;
    this.router.navigate([url], { queryParamsHandling: 'merge' });
  }
}
